export default "__VITE_ASSET__D3qh0w0q__"